// src/redux-store/types/loading.ts
export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';

export interface LoadingState {
  isLoading: boolean;
  loadingCount: number;
}
